import { navigate } from "gatsby";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function SearchForm({ onHideSearch }) {
  const { t } = useTranslation();
  const [term, setTerm] = useState("");

  const onSubmit = (event) => {
    event.preventDefault();
    onHideSearch();
    navigate(`/search?term=${term}`);
  };

  return (
    <div className="header-search header-search--active">
      <div className="header-search__form">
        <form onSubmit={onSubmit}>
          <input
            type="search"
            name="term"
            id=""
            className="header-search__input"
            placeholder={t("searchbar.input")}
            autoComplete="off"
            onChange={(event) => setTerm(event.target.value)}
          />
          <button
            type="button"
            className="header-search__button js-close__search"
            onClick={() => onHideSearch()}
          >
            {t("searchbar.close")}
          </button>
          <button
            type="submit"
            className="header-search__button js-submit__search"
          >
            {t("searchbar.search")}
          </button>
        </form>
      </div>
    </div>
  );
}
